import { action } from 'easy-peasy';
import { IActionSetMoreMobileUsers } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreMobileUsers: IActionSetMoreMobileUsers = action((state, payload) => {
  const hasMore = state.itemsPagination.itemsPerPage === payload.length;

  const newItems = mergeUniqueBy(state.items, payload, item => item.id);

  state.items = [...newItems];
  state.itemsPagination.page += 1;
  state.itemsPagination.hasMore = hasMore;
});

export default setMoreMobileUsers;
